var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-avatar',_vm._b({},'a-avatar',_vm.cellRendererParams,false)),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.value)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }